import ThumbnailRedux from './ThumbnailRedux';

export default ThumbnailRedux;